import { useMemo } from 'react'
import { cn } from '@/lib/utils'
import { sanitizeHtml } from '@/utils/sanitize'

interface HtmlContentProps {
  content: string
  className?: string
}

/**
 * Renderiza conteúdo HTML com classes de estilo prose.
 *
 * O HTML é sanitizado aqui, no único ponto por onde ele entra na árvore —
 * assim os seis lugares que usam este componente ficam cobertos de uma vez.
 * Antes o comentário afirmava ser seguro, mas o conteúdo ia cru para o
 * dangerouslySetInnerHTML.
 */
export function HtmlContent({ content, className }: HtmlContentProps) {
  const sanitizado = useMemo(() => sanitizeHtml(content ?? ''), [content])

  return (
    <div
      className={cn(
        'prose prose-sm max-w-none',
        'prose-headings:font-bold prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg',
        'prose-p:my-2 prose-p:leading-relaxed',
        'prose-ul:my-2 prose-ol:my-2 prose-li:my-0',
        'prose-blockquote:border-l-4 prose-blockquote:border-primary prose-blockquote:pl-4 prose-blockquote:italic',
        'prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:rounded',
        'prose-strong:font-semibold',
        'dark:prose-invert',
        className
      )}
      dangerouslySetInnerHTML={{ __html: sanitizado }}
    />
  )
}
